import { ReactNode } from 'react'

import { ZenkakuSpace } from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const scItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. Establishment of Information Security Management Systems</h3>
        <p>
          TRIAL Group shall strive to protect all information assets held by TRIAL Group and comply with laws, regulations, and other rules related to information security to establish strict information security management systems so that TRIAL Group can always gain the trust of society.
        </p>
      </>
    ),
    id: 'security1',
  },
  {
    children: (
      <>
        <h3>2. Assignment of Head of Information Security</h3>
        <p>
          TRIAL Group shall appoint a Head of Information Security and organize an Information Security Committee. Thereby, TRIAL Group shall assure an accurate assessing the status of information security throughout the company and proactively implement necessary measures in a timely manner.
        </p>
      </>
    ),
    id: 'security2',
  },
  {
    children: (
      <>
        <h3>3. Establishment of Internal Rules for Information Security</h3>
        <p>
          TRIAL Group shall establish internal rules based on the Information Security Policy to clearly state our policy on the handling of not only personal information but also information assets in general, and to make it known internally and externally that TRIAL Group shall take a strict attitude toward information security incidents, such as information leaks.
        </p>
      </>
    ),
    id: 'security3',
  },
  {
    children: (
      <>
        <h3>4. Reinforcement of Management System for Outsourcing Partners</h3>
        <p>
          When concluding an outsourcing contract, TRIAL Group shall fully investigate the suitability of the outsourcing party, conclude a contract necessary to protect information assets and maintain confidentiality, and conduct appropriate supervision.
        </p>
      </>
    ),
    id: 'security4',
  },
  {
    children: (
      <>
        <h3>5. Implementation of Education and Training</h3>
        <p>
          TRIAL Group shall provide our employees with thorough information security education and training so that all members involved with the TRIAL Group&apos;s information assets can perform their duties with an awareness of the importance of information security. 
        </p>
      </>
    ),
    id: 'security5',
  },
  {
    children: (
      <>
        <h3>6. Continuous Improvement of Information Security</h3>
        <p>
         To realize appropriate management systems according to the purpose of use and importance of information assets, TRIAL Group shall identify threats to information assets and continuously analyse and evaluate risks. Based on the risk assessment results, TRIAL Group shall implement reasonable information security measures against the identified threats and strive to safely manage information assets.
        </p>
      </>
    ),
    id: 'security6',
  },
  {
    children: (
      <>
        <h3>7. Others</h3>
        <p>
          Personal information shall be managed in accordance with the &quot;
          <LinkText path="/en/legal/privacy-policy/" text=" Privacy Policy" />
          &quot; published separately.
        </p>
      </>
    ),
    id: 'security7',
  },
  {
    children: (
      <>
        <p>
          Date of Enactment:
          <ZenkakuSpace />
          October 3, 2018
          <br />
          Date of Last Revision: 
          <ZenkakuSpace />
          November 22, 2022
        </p>
      </>
    ),
    id: 'signInfo',
  },
]

export const scLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（Establishment of Information Security Management Systems）',
      anchor: 'security1',
    },
    {
      name: '（Assignment of Head of Information Security）',
      anchor: 'security2',
    },
    {
      name: '（Establishment of Internal Rules for Information Security）',
      anchor: 'security3',
    },
  ],
  [
    {
      name: '（Reinforcement of Management System for Outsourcing Partners）',
      anchor: 'security4',
    },
    {
      name: '（Implementation of Education and Training）',
      anchor: 'security5',
    },
    {
      name: '（Continuous Improvement of Information Security）',
      anchor: 'security6',
    },
    {
      name: '（Others）',
      anchor: 'security7',
    },
  ],
]
